import {h, Fragment} from "preact"
import { SerpElement, useAppState, useCurrencyFormatting } from '@nosto/preact'
import { useEffect, useMemo } from 'preact/hooks';
import { atc, getSrcset } from '../helpers'

export default function Product({ product }) {
    const { format } = useCurrencyFormatting();

    const discount = useMemo(() => {
        if(!product.listPrice || product.listPrice <= product.price) return false;
        const difference = product.listPrice - product.price
        return {
            amount: difference,
            percent: ((difference / product.listPrice) * 100).toFixed(2),
        }
    }, [])

    return (
        <SerpElement
            as="li"
            hit={product}
            class="grid__item product-item search-product-card scroll-trigger animate--slide-in"
        >
            <div class="underline-links-hover">
                <div class={`card1 card card--standard card--media card1--${product.productId}`} style="--ratio-percent: 100%;">
                    <a href={product.url} class="full-unstyled-link" aria-hidden="true">
                        <div class="you_may_also_like card-pro card__inner color-background-2 ratio" style="--ratio-percent: 100%;">
                            <div class="card__media">
                                <div class="media media--transparent media--hover-effect" style="width: 97%; height: 97%; margin: auto 3px;">
                                    <img
                                        srcset={getSrcset(product.imageUrl)}
                                        src={`${product.imageUrl.replace('.jpg', '_533x.jpg').replace('.png', '_533x.png').replace('.webp', '_533x.webp')}`}
                                        sizes="(min-width: 1220px) 272px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                                        alt={product.name}
                                        class="motion-reduce img-reduce"
                                        loading="lazy"
                                        width="1000"
                                        height="1000"
                                    />
                                </div>
                            </div>
                        </div>
                    </a>

                    <div class="card-info card__content">
                        <div class="product_tag_promote">{" "}</div>

                        <div class="card__information">
                            <h3 class="card-head h5">
                                <a href={product.url} class="full-unstyled-link full-unstyled-link-1">
                                    {product.name}
                                </a>
                            </h3>
                            <div class="card-information">
                                <span class="caption-large light"></span>
                                <link href="//mac-center.com/cdn/shop/t/214/assets/price-carousel.css?v=78190447634955585811730957528" rel="stylesheet" type="text/css" media="all" />
                                <div 
                                    class={`fbt_cartCSS price price-product ${(product.listPrice && product.listPrice > product.price) ? 'price--on-sale' : ''}`}
                                    data-prodprice={`${format(product.price)}`}
                                >
                                    <div class="price__container_carousel price__container_">
                                        
                                        <div class="price__regular">
                                            <div class="price-item-old-1">
                                                <span class="price-item price-item--regular">
                                                    {format(product.price)}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="price__sale">
                                            <div class="price__sale_div">
                                                <div class="price-item-old-1-1">
                                                    <span class="price-old-class-1">
                                                        {format(product.listPrice)}
                                                    </span>
                                                </div>
                                                <div class="price-segment-discount-div-1">
                                                    <span class="price-item price-item--sale price-item--last price-item-sale-2">
                                                        {format(product.price)}
                                                    </span>
                                                    <br />

                                                    <span class="price-segment-discount-1 price_discount_slider">
                                                        {discount?.percent ? `-${discount.percent}%` : ''}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <small class="unit-price caption hidden">
                                            <span class="visually-hidden">Precio unitario</span>
                                            <span class="price-item price-item--last">
                                                <span></span>
                                                <span aria-hidden="true">/</span>
                                                <span class="visually-hidden">&nbsp;por&nbsp;</span>
                                                <span> </span>
                                            </span>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <input type="hidden" id={`list-name-${product.productId}`} class="list-name" value="" />
                <input type="hidden" id={`var_id-${product.productId}`} class="variant-id" value={product.skus?.[0].id} />
                <input type="hidden" id={`title_${product.productId}`} class="fbt-value frequent-products-tittlr" value={product.name} />
                <input type="hidden" id={`product_id_${product.productId}`} class="fbt-value frequent-products-ids" value={product.productId} />
                <input type="hidden" class="fbt-value item_currency" value={product.priceCurrencyCode || "COP"} />
                <input type="hidden" id={`product_price-${product.productId}`} class="fbt-value card_product_price_ item_price" value={product.price} />
                <input type="hidden" id={`product_com_price-${product.productId}`} class="fbt-value card_product_compare_price_ item_compare_price" value={product.listPrice} />
                <input type="hidden" id={`item_list_page-${product.productId}`} class="fbt-value card_product_list_ item_list_page" value="nosto-search" />

                <div class="button-cart">
                    <div class="product-form__buttons card-slider-buttons button_primary_clckd">
                        <a 
                            href={product.url} 
                            class="button_primary_anchor card-btn button--full-width button--primary"
                        >
                            Añadir al carrito
                        </a>
                    </div>
                </div>
            </div>
        </SerpElement>
    )
}

                